import { observer } from 'mobx-react-lite';
import { FC, useCallback } from 'react';

import { IWaitingRoomMember } from '@gem/call/Model/callModel.types';
import { List } from '@gem/call/Removable/components/List/List';

import { useWaitingRoomListPresenter } from './WaitingRoomList.presenter';
import styles from './WaitingRoomList.styles.m.css';
import { WaitingRoomMemberCard } from './WaitingRoomMemberCard/WaitingRoomMemberCard';

export const WaitingRoomList: FC = observer(() => {
  const presenter = useWaitingRoomListPresenter();

  const renderItem = useCallback((member: IWaitingRoomMember) => {
    return <WaitingRoomMemberCard member={member} />;
  }, []);

  return (
    <div className={styles.container}>
      <List
        data={presenter.members}
        keyExtractor={presenter.keyExtractor}
        renderItem={renderItem}
      />
    </div>
  );
});
